<template>
  <div v-if="showItem">
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  props: {
    showExtraSmall: { required: false },
    showMobile: { type: Boolean, default: true },
    showTablet: { type: Boolean, default: true },
    showDesktop: { type: Boolean, default: true }
  },
  data () {
    return {
      display: '',
      showItem: false
    }
  },
  mounted () {
    this.onInit(window.innerWidth)
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    setShowItem (size) {
      if(typeof this.showExtraSmall == 'boolean' ){
        if (size === 'xs') {
          return this.showExtraSmall
        }
        else if (size === 'sm') {
          return this.showMobile
        }
        else if (size === 'md') {
          return this.showTablet
        } else {
          return this.showDesktop
        }
      }else{
        if (size === 'sm' || size === 'xs') {
          return this.showMobile
        }
        else if (size === 'md') {
          return this.showTablet
        } else {
          return this.showDesktop
        }
      }
    },
    onResize () {
      if (window.innerWidth > 992) {
        this.display = 'lg'
        this.showItem = this.setShowItem(this.display)
      } else if (window.innerWidth > 768) {
        this.display = 'md'
        this.showItem = this.setShowItem(this.display)
      } else if (window.innerWidth > 576) {
        this.display = 'sm'
        this.showItem = this.setShowItem(this.display)
      } else {
        this.display = 'xs'
        this.showItem = this.setShowItem(this.display)
      }
    },
    onInit (size) {
      if (size > 992) {
        this.display = 'lg'
        this.showItem = this.setShowItem(this.display)
      } else if (size > 768) {
        this.display = 'md'
        this.showItem = this.setShowItem(this.display)
      } else if (window.innerWidth > 576) {
        this.display = 'sm'
        this.showItem = this.setShowItem(this.display)
      } else {
        this.display = 'xs'
        this.showItem = this.setShowItem(this.display)
      }
    }
  }
}
</script>
